import { useAppState } from "../appState";

export function useUser() {
    const [user] = useAppState("user");
    const [isUserFetchDone] = useAppState("isUserFetchDone");
    return { user, isUserFetchDone };
}
